module.exports = __webpack_public_path__ + "static/media/copied.e6429fc6.png";